<template>
  <case-update-card
    :info-item="lawsuitCaseReply"
    :icon="'mdi-reply-outline'"
    :header="local.caseFile.cards.lawsuitCaseReply.header"
    :code-display-name="local.caseFile.cards.lawsuitCaseReply.applicantName"
    :code="lawsuitCaseReply.name"
    :status="lawsuitCaseReply.identityNumber"
    :status-display-name="local.caseFile.cards.lawsuitCaseReply.identityNumber"
    :date="lawsuitCaseReply.creationDate"
    :date-display-name="local.caseFile.cards.lawsuitCaseReply.dateDisplayName"
    :has-actions="true"
    :court-name="``"
    :sub-circle-name="``"
    @card-click="$emit('lawsuit-case-reply-card-click',lawsuitCaseReply)"
  >
  </case-update-card>
</template>

<script>
import CaseUpdateCard from './case-update-card.vue';

export default {
  name: 'LawsuitCaseReplyCard',
  components: { CaseUpdateCard },
  props: {
    lawsuitCaseReply: {
      type: Object,
      required: true,
    },
    isPega: {
      type: [String, Boolean],
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};

</script>
<style scoped>
.header-text {
  font-size: 18px;
}

::v-deep .case-update-card-header {
  color: var(--app-dark-primary-color);
  font-size: 25px;
}
</style>
